export const POD_CONFIG_SELECT_FACILITY = "POD_CONFIG_SELECT_FACILITY";
export const POD_CONFIG_GET_FACILITES = "POD_CONFIG_GET_FACILITES";
export const POD_CONFIG_GET_FACILITES_SUCCESS = "POD_CONFIG_GET_FACILITES_SUCCESS";
export const POD_CONFIG_SELECT_FACILITY_FETCH_DATA_SUCCESS = "POD_CONFIG_SELECT_FACILITY_FETCH_DATA_SUCCESS";
export const POD_CONFIG_SUBMIT_FORM_DATA = "POD_CONFIG_SUBMIT_FORM_DATA";